import React from 'react';
import PropTypes from 'prop-types';
import 'moment/locale/pl';

import Moment from 'react-moment';

const Date = ({ date, locale }) => (
  <Moment element="span" locale={locale} format="LL">
    {date}
  </Moment>
);

Date.propTypes = {
  date: PropTypes.string.isRequired,
  locale: PropTypes.string.isRequired,
};

export default Date;
